import { IShareContentState } from "@src/atoms/shareContentAtom";

export default function base64ToFile(item: IShareContentState): File {
    let base64 = item.dataBase64

    if (base64.includes(','))
        base64 = base64.split(',')[1]

    base64 = base64
        .replace(/-/g, '+')
        .replace(/_/g, '/')

    while (base64.length % 4)
        base64 += '='

    const bin = atob(base64)
    const bytes = new Uint8Array(bin.length)

    for (let i = 0; i < bin.length; i++)
        bytes[i] = bin.charCodeAt(i)

    return new File([bytes], item.name, {
        type: item.mimeType
    })
}